import billingApi from '@/lib/billingApi'

export type EggVariable = {
  id: number
  name: string
  description?: string
  env_variable: string
  default_value?: string
  rules?: string
  user_viewable?: boolean
  user_editable?: boolean
}

export type EggConfigurationApply = 'none' | 'restart' | 'reinstall'
export type EggConfigurationControl = 'auto' | 'text' | 'password' | 'number' | 'slider' | 'select' | 'toggle'

export type EggConfigurationChoice = {
  value: string
  label: string
}

export type EggConfigurationCategoryOverride = {
  id: string
  label: string
  order?: number
  advanced?: boolean
}

export type EggConfigurationFieldOverride = {
  label?: string
  description?: string
  category?: string
  control?: EggConfigurationControl
  choices?: EggConfigurationChoice[]
  order?: number
  hidden?: boolean
  advanced?: boolean
  recommended?: boolean
  apply?: EggConfigurationApply
}

export type EggConfiguration = {
  version: 1
  categories: EggConfigurationCategoryOverride[]
  fields: Record<string, EggConfigurationFieldOverride>
}

export type EggDetails = {
  id: number
  uuid: string
  name: string
  docker_image?: string
  startup?: string
  variables: EggVariable[]
  configuration?: EggConfiguration
}

export type ServerEggMetadata = {
  server_uuid: string
  egg_id: number
  egg_name: string
  nest_id: number
  nest_name: string
  service_type: string
}

export type OwnedServerMetadata = Record<string, ServerEggMetadata>

export async function getEggDetails(eggId: number): Promise<EggDetails> {
  const res = await billingApi.get<{ data: EggDetails }>(`/subscription/eggs/${eggId}`)
  if (!res.data?.data) throw new Error('No egg data')
  return res.data.data
}

export async function getServerEggMetadata(serverUuid: string): Promise<ServerEggMetadata> {
  const res = await billingApi.get<{ data: ServerEggMetadata }>(
    `/hoard-api/servers/${encodeURIComponent(serverUuid)}/metadata`,
  )
  if (!res.data?.data?.egg_id) throw new Error('No egg metadata')
  return res.data.data
}

export async function getOwnedServerMetadata(): Promise<OwnedServerMetadata> {
  const res = await billingApi.get<{ data: OwnedServerMetadata }>('/hoard-api/servers/metadata')
  return res.data?.data || {}
}

export default { getEggDetails, getServerEggMetadata, getOwnedServerMetadata }
